import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum AttemptType {
  Charge = 1,
  Cancellation = 2,
  UpdateDueDate = 3,
  UpdateValue = 4,
  ManualCharge = 5,
}
EnumDescriptions.setDescriptions(AttemptType, [
  i18n.t('enums.charge'),
  i18n.t('enums.cancellation'),
  i18n.t('enums.update_due_date'),
  i18n.t('enums.update_value'),
  i18n.t('enums.manual_charge'),
]);
